import React, { useState } from "react"
import Popup from "component/popup/popup"
import { agent } from "apiClient/api"
import { useSnackbar } from "context/snackbarContext"
import styles from "./configuration.module.scss"
import { displayUserName, ConfigurationUser } from "./configurationUsers"

type SetUserStatusPopupProps = {
    isOpen: boolean
    user: ConfigurationUser | null
    onCancel: () => void
    onSuccess: () => void
}

const SetUserStatusPopup: React.FC<SetUserStatusPopupProps> = ({ isOpen, user, onCancel, onSuccess }) => {
    const { showSuccess, showError } = useSnackbar()
    const [isSaving, setIsSaving] = useState(false)
    const settingActive = user ? !user.flag_active : false
    const target = settingActive ? "active" : "inactive"
    const name = user ? displayUserName(user) : ""

    const handleConfirm = async () => {
        if (!user) return
        setIsSaving(true)
        try {
            const response = await agent.UpdateUserAPI.put({
                private_user_id: user.private_user_id,
                flag_active: settingActive,
            })
            if (response?.status === true) {
                showSuccess(settingActive ? "User set as active" : "User set as inactive")
                onSuccess()
                onCancel()
            } else {
                showError(response?.error?.message || "Failed to update user status")
            }
        } catch (err) {
            console.error("Update user status error", err)
            showError("Failed to update user status")
        } finally {
            setIsSaving(false)
        }
    }

    return (
        <Popup
            isOpen={isOpen}
            onClose={onCancel}
            title={`Set user as ${target}?`}
            size="medium"
            showCloseButton={false}
            secondaryButton={{ label: "Cancel", onClick: onCancel }}
            primaryButton={{ label: isSaving ? "Saving..." : `Set as ${target}`, onClick: handleConfirm, disabled: isSaving }}
        >
            <p className={styles.confirmBody}>
                {settingActive
                    ? `${name} will be able to sign in again.`
                    : `${name} will no longer be able to sign in. You can set this user as active again at any time.`}
            </p>
        </Popup>
    )
}

export default SetUserStatusPopup
